import { autoFitTextbox, setTextPreservingStyles } from '../../text';
import { AutoFitTextAlign, AutoFitTextbox } from '../types';

const refit = (t: AutoFitTextbox): void => {
  autoFitTextbox(t, t.autoFit);
};

// Text content

export const getAutoFitTextContent = (t: AutoFitTextbox): string => t.text ?? '';

export const setAutoFitTextContent = (t: AutoFitTextbox, text: string): void => {
  setTextPreservingStyles(t, text);
  refit(t);
};

// Color

export const getAutoFitTextFill = (t: AutoFitTextbox): string => (t.fill as string) ?? '';

export const setAutoFitTextFill = (t: AutoFitTextbox, color: string): void => {
  t.set('fill', color);
  t.canvas?.requestRenderAll();
};

// Typography

export const setAutoFitTextFontFamily = (t: AutoFitTextbox, value: string): void => {
  t.set('fontFamily', value);
  refit(t);
};

export const setAutoFitTextFontWeight = (t: AutoFitTextbox, value: number | string): void => {
  t.set('fontWeight', value);
  refit(t);
};

export const setAutoFitTextFontStyle = (t: AutoFitTextbox, value: 'normal' | 'italic'): void => {
  t.set('fontStyle', value);
  t.canvas?.requestRenderAll();
};

export const setAutoFitTextAlign = (t: AutoFitTextbox, value: AutoFitTextAlign): void => {
  t.set('textAlign', value);
  t.canvas?.requestRenderAll();
};

// Spacing

export const setAutoFitTextLineHeight = (t: AutoFitTextbox, value: number): void => {
  t.set('lineHeight', value);
  refit(t);
};

export const setAutoFitTextCharSpacing = (t: AutoFitTextbox, value: number): void => {
  t.set('charSpacing', value);
  refit(t);
};

// Constraints

export const getAutoFitTextWidth = (t: AutoFitTextbox): number => t.width ?? 0;

export const setAutoFitTextWidth = (t: AutoFitTextbox, value: number): void => {
  t.set('width', value);
  refit(t);
};

export const getAutoFitTextMaxHeight = (t: AutoFitTextbox): number => t.autoFit.maxHeight;

export const setAutoFitTextMaxHeight = (t: AutoFitTextbox, value: number): void => {
  t.autoFit.maxHeight = value;
  refit(t);
};

export const getAutoFitTextMinFontSize = (t: AutoFitTextbox): number => t.autoFit.minFontSize;

export const setAutoFitTextMinFontSize = (t: AutoFitTextbox, value: number): void => {
  t.autoFit.minFontSize = value;
  refit(t);
};

export const getAutoFitTextMaxFontSize = (t: AutoFitTextbox): number => t.autoFit.maxFontSize;

export const setAutoFitTextMaxFontSize = (t: AutoFitTextbox, value: number): void => {
  t.autoFit.maxFontSize = value;
  refit(t);
};

export const getAutoFitTextSnapTo = (t: AutoFitTextbox): number => t.autoFit.snapTo ?? 1;

export const setAutoFitTextSnapTo = (t: AutoFitTextbox, value: number): void => {
  t.autoFit.snapTo = value;
  refit(t);
};

export const getAutoFitTextSplitByGrapheme = (t: AutoFitTextbox): boolean => !!t.splitByGrapheme;

export const setAutoFitTextSplitByGrapheme = (t: AutoFitTextbox, value: boolean): void => {
  t.set('splitByGrapheme', value);
  refit(t);
};

/** Read-only — the fontSize autoFitTextbox last resolved. */
export const getAutoFitTextResolvedFontSize = (t: AutoFitTextbox): number => t.fontSize ?? 0;
